import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'input-range',
  standalone:true,
  templateUrl: './input-range.component.html',
  styleUrls: ['./input-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputRangeComponent),
    multi: true
  }]
})
export class InputRangeComponent implements ControlValueAccessor {
  constructor(private cdr: ChangeDetectorRef) {}

  /* API externa */
  @Input() min  = 0;
  @Input() max  = 90;
  @Input() step = 15;

  /* valor interno */
  private _value = 0;
  get value() { return this._value; }

  /* Host bindings (movem a bolinha) */
  @HostBinding('style.--value')      get cssValue()     { return this._value; }
  @HostBinding('style.--text-value') get cssTextValue() { return `"${this._value}"`; }
  @HostBinding('style.--min')        get cssMin()  { return this.min; }
  @HostBinding('style.--max')        get cssMax()  { return this.max; }
  @HostBinding('style.--step')       get cssStep() { return this.step; }

  private onChange: (v: number)=>void = () => {};
  private onTouched: ()=>void = () => {};
  disabled = false;

  writeValue(v: number|null): void {
    if (v !== null && v !== undefined) {
      this._value = v;
      this.cdr.markForCheck();   // <<---- força atualização
    }
  }
  registerOnChange(fn: (v: number)=>void) { this.onChange = fn; }
  registerOnTouched(fn: ()=>void) { this.onTouched = fn; }
  setDisabledState(isDis: boolean) { this.disabled = isDis; }

  /* handler do usuário */
  handleInput(event: Event) {
    const newVal = +(event.target as HTMLInputElement).value;
    this._value = newVal;
    this.onChange(newVal);
    // não precisa de markForCheck(); o próprio evento já dispara CD no OnPush
  }
}
